import { useState } from "react";

export function Dropdown({ title, children }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="my-2">
      <div
        className="cursor-pointer font-bold"
        onClick={() => setOpen(!open)}
      >
        {title} {open ? "▲" : "▼"}
      </div>
      {open && <div className="pl-4">{children}</div>}
    </div>
  );
}
